import { render, staticRenderFns } from "./ComponenteModale.vue?vue&type=template&id=1c4fe9fc&"
import script from "./ComponenteModale.vue?vue&type=script&lang=js&"
export * from "./ComponenteModale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports